import { useI18n } from '@monorepo/i18n';
import PrivacyPolicy from '../Login/components/PrivacyPolicy';
import AuthWrapper from '../../common/AuthWrapper';
import TempoparyUserRegisterForm from './components/Form';

type TLoginProps = {
  config: { logoSrc: string };
};

const TemporaryUserRegister: Component<TLoginProps> = ({ config }) => {
  const { logoSrc } = config;
  const { t } = useI18n();

  return (
    <AuthWrapper
      header={t('login.greetings')}
      subHeader={t('register.description')}
      logoSrc={logoSrc}
    >
      <TempoparyUserRegisterForm />
      <PrivacyPolicy />
    </AuthWrapper>
  );
};

export default TemporaryUserRegister;
